import { Sidebar } from "../Layout/Sidebar";
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';

import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";


const Menu = () => {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [query, setQuery] = useState('');

  const deleteItem = async (id: number) => {
    if(confirm('آیا مطمئن هستید؟')){
      dispatch(setLoading(true));

      const res = await restApi(process.env.REACT_APP_BASE_URL + '/admin/menu/' + id, true).delete({});

      if(res.code == 204){
        Swal.fire({
          title: 'موفق',
          text: 'منو با موفقیت حذف شد',
          icon: 'success',
          confirmButtonText: 'متوجه شدم'
        })
      } else {
        Swal.fire({
          title: 'ناموفق',
          text: res?.data,
          icon: 'error',
          confirmButtonText: 'متوجه شدم'
        })
      }

      dispatch(setLoading(false));
    }
  }

  const list = () => {
    const rows = [];

    data.filter((menu:any) => menu.title.toLowerCase().includes(query.toLowerCase())).map((menu: any, index) => {
      rows.push(
        <tr
          className={`dashTr2 ${index % 2 === 0 ? 'table-row-even' : 'table-row-odd'}`}
          key={`menu-${menu.id}-${index}`}
        >
          <td className="svgContainer">
            <i className="trash clickable" onClick={() => deleteItem(menu.id)}></i>
            <i className="edit clickable" onClick={() => navigate('/menu/edit/' + menu.id)}></i>
          </td>
          <td className="">{menu.createdAt}</td>
          <td className="">{menu.description}</td>
          <td className="">{menu.slug}</td>
          <td className="">{menu.title}</td>
          <td className="">{menu?.parent?.title}</td>
          <td>{index + 1}</td>
        </tr>
      )
    })

    return rows;
  };

  const fetchData = async () => {
    dispatch(setLoading(true));

    const res = await restApi(process.env.REACT_APP_BASE_URL + '/admin/menu', true).get();
    console.log(res)
    if(res.code == 200){
      setData(res.data);
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return(

    <>
      <body className="dashboardBody">
      <Sidebar />
      <main className="dashBoardMain">
        <h1 className="dashBoardTitle">لیست منو</h1>
        <div className="searchContainer">
          <span className="dashboardHeader clickable" onClick={() => navigate('/menu/add')}>
           افزودن منو جدید
            <i className="addPlus"></i>
          </span>
          <div className="dashboardseaechBox">
            <i className="dashMagnifierIcon"></i>
            <input className="dashSearchInput" placeholder="جستجو" onChange={(input: any) => setQuery(input.target.value)}></input>
          </div>
        </div>
        <table className="alternating-table listTable">
          <thead>
          <tr className="dashTr1 firstTR">
            <th>عملیات</th>
            <th>تاریخ ساخت</th>
            <th>توضیحات</th>
            <th>اسلاگ</th>
            <th>عنوان</th>
            <th>والد</th>
            <th>ردیف</th>
          </tr>
          </thead>
          <tbody>
          {list()}
          </tbody>
        </table>
      </main>
      </body>
    </>
  )
}
export default Menu;